var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-with-label-box"
  }, [_c('span', {
    staticClass: "container-with-label-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };